module.exports = __webpack_public_path__ + "img/02.1f4ac35f.png";